import React, { useEffect, useState } from 'react'
import { Card, Form, Row, Col, Button, Skeleton, Select, message } from 'antd'
import { useHistory } from 'react-router-dom'
import { useAuthSelector } from 'store/authSlice/authReducer'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { changeActiveRole, resetActiveRole } from 'store/authSlice/authActions'
import { UserMessageView } from 'components/elements'
import { config } from 'configs'

const schema = Yup.object().shape({
  role: Yup.string().required('Select role'),
})

const roleValidations = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value })
  },
}

const initialValues = {
  role: '',
}

const MyRoles = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { userRoles, activeRole } = useAuthSelector()
  const [form] = Form.useForm()
  Form.useWatch('role', form)
  const [loading, setLoading] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)

  useEffect(() => {
    if (activeRole) {
      form.setFieldsValue({
        role: activeRole?.RoleId,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeRole])

  const successAction = () => {
    message.success('Role changed successfully')
    history.push('/settings/account')
  }

  const handleResetRoleToDefault = () => {
    setResetLoading(true)
    const haveOrganizationAdminRole = userRoles?.find((item) =>
      item.Roles?.includes(config.organizationAdmin),
    )
    if (haveOrganizationAdminRole) {
      dispatch(
        changeActiveRole({
          role: haveOrganizationAdminRole,
          actions: successAction,
          setLoading: setResetLoading,
        }),
      )
    } else {
      dispatch(
        resetActiveRole({
          setLoading: setResetLoading,
          actions: successAction,
        }),
      )
    }
  }

  const onFinish = async (values) => {
    const selectedRole = userRoles.find((item) => item.RoleId === values.role)
    if (selectedRole) {
      setLoading(true)
      dispatch(
        changeActiveRole({
          role: selectedRole,
          actions: successAction,
          setLoading,
        }),
      )
    } else {
      message.error('Role not found')
    }
  }

  const buttonText = 'Save'
  return (
    <Card
      className="header-solid"
      bordered={false}
      title={[
        <>
          <h6 className="mb-0 t-text-2xl">Select Organization</h6>
          <p className="font-regular">Switch between organization</p>
        </>,
      ]}
    >
      <Skeleton loading={false} active paragraph={{ rows: 18 }}>
        {userRoles.length > 0 ? (
          <Form
            form={form}
            layout="vertical"
            key={0}
            onFinish={onFinish}
            name="Role Form"
            initialValues={initialValues}
            scrollToFirstError
          >
            <Row gutter={[24, 0]}>
              <Col span={24}>
                <Form.Item name="role" rules={[roleValidations]}>
                  <Select placeholder="Select role" style={{ width: '100%' }}>
                    {userRoles.map((item, index) => (
                      <Select.Option value={item?.RoleId} key={index}>
                        {item?.OrganizationName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24} className="text-right t-space-x-2">
                <Button
                  disabled={loading || resetLoading}
                  type="primary"
                  className="px-25"
                  onClick={() => history.goBack()}
                >
                  Cancel
                </Button>
                <Button
                  loading={resetLoading}
                  disabled={loading}
                  type="primary"
                  className="px-25"
                  onClick={() => handleResetRoleToDefault()}
                >
                  Reset to default
                </Button>
                <Button
                  loading={loading}
                  disabled={resetLoading}
                  type="primary"
                  className="px-25"
                  htmlType="submit"
                >
                  {buttonText}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <UserMessageView
            heading="No roles found"
            subHeading="No organization has assigned you any roles yet"
          />
        )}
      </Skeleton>
    </Card>
  )
}

export { MyRoles }
